import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [160, 127.18, 365.75],
  minDistance: 100,
  maxDistance: 500,
  minAzimuthAngle: -(Math.PI / 2 - 0.5),
  maxAzimuthAngle: Math.PI / 2 - 0.5,
  minPolarAngle: 0.3,
  maxPolarAngle: Math.PI / 2 + 0.2,
  target: [0, 50, 0],
  getShadowManXPosition: (width: number) => -width / 2 - 50,
}
